/** EMBER & PALM — one global hospitality layout, real pages for every high-value customer journey. */
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Redirect, Route, Switch, useLocation } from "wouter";
import { AppProviders } from "./AppProviders";
import ErrorBoundary from "./components/ErrorBoundary";
import { RestaurantSchema } from "./components/RestaurantSchema";
import { SiteLayout } from "./components/SiteLayout";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import MenuPage from "./pages/Menu";
import LunchPage from "./pages/Lunch";
import OurStoryPage from "./pages/OurStory";
import GroupsFunctionsPage from "./pages/GroupsFunctions";
import LocationPage from "./pages/Location";
import {
  FishAmokPage,
  MelbourneRestaurantPage,
  NearMarvelPage,
} from "./pages/SeoLanding";
import PrivacyPage from "./pages/Privacy";
import RecipesPage from "./pages/Recipes";
import WholesalePage from "./pages/Wholesale";
import LinksPage from "./pages/Links";
import MarvelPage from "./pages/Marvel";
import { AmokPasteProductPage, ShopPage } from "./pages/Products";
import BlogPage from "./pages/Blog";
import BeefLocLacArticlePage from "./pages/BeefLocLacArticle";
import CambodianDessertsArticlePage from "./pages/CambodianDessertsArticle";
import KhmerFamilyRecipesArticlePage from "./pages/KhmerFamilyRecipesArticle";
import KampotPepperArticlePage from "./pages/KampotPepperArticle";
import VegetarianCambodianFoodArticlePage from "./pages/VegetarianCambodianFoodArticle";
import ChristmasPartyArticlePage from "./pages/ChristmasPartyArticle";
import AmokAtHomeArticlePage from "./pages/AmokAtHomeArticle";
function Router() {
  // make sure to consider if you need authentication for certain routes
  const [location] = useLocation();

  if (location === "/links") return <LinksPage />;
  if (location === "/marvel") return <MarvelPage />;

  return (
    <SiteLayout>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/menu" component={MenuPage} />
        <Route path="/lunch" component={LunchPage} />
        <Route path="/our-story" component={OurStoryPage} />
        <Route path="/groups-functions" component={GroupsFunctionsPage} />
        <Route path="/events"><Redirect to="/groups-functions" replace /></Route>
        <Route path="/location" component={LocationPage} />
        <Route path="/blog" component={BlogPage} />
        <Route path="/blog/beef-loc-lac-melbourne" component={BeefLocLacArticlePage} />
        <Route path="/blog/cambodian-desserts-melbourne" component={CambodianDessertsArticlePage} />
        <Route path="/blog/khmer-family-recipes-melbourne" component={KhmerFamilyRecipesArticlePage} />
        <Route path="/blog/kampot-pepper-melbourne" component={KampotPepperArticlePage} />
        <Route path="/blog/vegetarian-cambodian-food-melbourne" component={VegetarianCambodianFoodArticlePage} />
        <Route path="/blog/christmas-party-venue-west-melbourne" component={ChristmasPartyArticlePage} />
        <Route path="/blog/how-to-make-fish-amok-at-home" component={AmokAtHomeArticlePage} />
        <Route path="/fish-amok-melbourne" component={FishAmokPage} />
        <Route
          path="/restaurant-near-marvel-stadium-southern-cross"
          component={NearMarvelPage}
        />
        <Route
          path="/cambodian-restaurant-melbourne-cbd"
          component={MelbourneRestaurantPage}
        />
        <Route path="/cambodian-restaurant-melbourne">
          <Redirect to="/cambodian-restaurant-melbourne-cbd" replace />
        </Route>
        <Route path="/southeast-asian-restaurant-melbourne">
          <Redirect to="/cambodian-restaurant-melbourne-cbd" replace />
        </Route>
        <Route path="/products" component={ShopPage} />
        <Route
          path="/products/angkor-amok-curry-paste-280g"
          component={AmokPasteProductPage}
        />
        <Route path="/products/kroeung-paste">
          <Redirect to="/" replace />
        </Route>
        <Route path="/products/amok-paste">
          <Redirect to="/products/angkor-amok-curry-paste-280g" replace />
        </Route>
        <Route path="/products/cambodian-bbq-sauce">
          <Redirect to="/" replace />
        </Route>
        <Route path="/recipes" component={RecipesPage} />
        <Route path="/wholesale" component={WholesalePage} />
        <Route path="/privacy" component={PrivacyPage} />
        <Route path="/404" component={NotFound} />
        <Route component={NotFound} />
      </Switch>
    </SiteLayout>
  );
}

function App() {
  return (
    <AppProviders>
      <ErrorBoundary>
        <ThemeProvider defaultTheme="light">
          <TooltipProvider>
            <RestaurantSchema />
            <Toaster />
            <Router />
          </TooltipProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </AppProviders>
  );
}

export default App;
